<template>
  <div :class="bem.e('header')">
    <!-- input -->
    <ll-input
      :value="props.searchValue"
      placeholder="请输入关键字"
      @change="throttleInputChange"
    >
      <template #prefix>
        <ll-icon icon-name="icon-search" :class="bem.e('header-icon')" />
      </template>
    </ll-input>
    <!-- add -->
    <ll-button
      v-if="isShowAddBtn"
      :class="`${bem.e('header-button')}`"
      @click="handleClick"
    >
      <ll-icon icon-name="icon-add" />
    </ll-button>
  </div>
</template>

<script lang="ts" setup>
import _ from 'lodash'
import { createNamespace } from '@ll-plus/utils'
import {
  treeSelectHeaderSearchProps,
  treeSelectHeaderSearchEmits
} from '../config'

// 1.defineOptions
defineOptions({ name: 'LlTreeSelectHeaderSearch' })

// 2.props/emits
const props = defineProps(treeSelectHeaderSearchProps)
const emits = defineEmits(treeSelectHeaderSearchEmits)

// 3.ref
// const searchValue = ref('')
const bem = createNamespace('tree-search')

// 4.methods
const handleInputChange = (e: any) => {
  props.onSearchInputChange && props.onSearchInputChange(e.target.value)
}
const handleClick = (e: Event) => emits('click', e)
// 搜索菜单列表节流
const throttleInputChange = _.throttle(handleInputChange, props.throttleTime)
</script>
